
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/making-customizable-components",
      function () {
        return require("private-next-pages/blog/making-customizable-components.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/making-customizable-components"])
      });
    }
  